<!-- Skeleton table while loading — rows float in with the entrance cascade;
     the real table below then replaces it in place, instantly (skipEntrance). -->
@if (!properties) {
  <tidy-table
    [skeletonLoading]="true"
    [columnslabels]="headers" />
}

<!-- Table -->
@if (shownRows?.length) {
  <tidy-table
    #tidyTable
    [dataSource]="shownRows"
    [displayedColumns]="headers"
    [columnslabels]="headers"
    (sortChange)="sortChanged($event)"
    [showColumnLines]="false"
    [rowsToShow]="shownRows?.length"
    [allRowIsClickable]="true"
    (cellClick)="onTableColumnClick($event)"
    [infiniteScroll]="!allDataLoaded"
    [totalRows]="shownRows?.length"
    [isLoading]="isLoadingMore"
    [skipEntrance]="true"
    (pageChange)="pageChange($event)" />
}

<!-- No Results -->
@if (shownRows?.length === 0 && properties?.length > 0) {
  <tidy-alert>
    <tidy-row>
      <tidy-text [body]="'No scheduled items found'" />
    </tidy-row>
  </tidy-alert>
}
